module.exports = __webpack_public_path__ + "static/media/day07.6c28687c.jpg";